import type { TdHTMLAttributes } from 'react'
import { useLoaderData } from '@tanstack/react-router'
import { formatDateDayTime, isDateLike } from '@/utils/dates';
import { joinClasses } from '@/utils/styling';
import { stripAriaSelected } from '@/components/shared/tables/KendoTableClientState/kendo-cell-utils';

type Props = {
    children?: React.ReactNode;
    tdProps?: TdHTMLAttributes<HTMLTableCellElement> | null;
};

export default function TableDateCell({ children, tdProps }: Props) {
    const globalState = useLoaderData({ from: "__root__" })
    const cleanTdProps = stripAriaSelected(tdProps);

    if (!isDateLike(children)) {
        if (globalState?.env !== "Production") {
            console.error("TableDateCell expected Date|string, got:", children);
        }
        return (
            <td {...cleanTdProps} className={joinClasses("text-nowrap", cleanTdProps?.className)}>
                <span className="text-muted">—</span>
            </td>
        );
    }

    return (
        <td {...cleanTdProps} className={joinClasses("text-nowrap", cleanTdProps?.className)}>
            {formatDateDayTime(children)}
        </td>
    )
}